import React, { PropsWithChildren } from 'react';
import { Box, BoxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useLayoutElementsHeight } from 'hooks/useLayoutElementsHeight';

type ScrollableContainerProps = PropsWithChildren<BoxProps>;

export const ScrollableContainer = ({ children, sx, ...boxProps }: ScrollableContainerProps) => {
  const { commonContentHeight } = useLayoutElementsHeight();
  const composedSx = [
    (theme: Theme) => ({
      height: commonContentHeight,
      overflowY: 'auto',
      overscrollBehaviorY: 'none',
      WebkitOverflowScrolling: 'touch',
      backgroundColor: theme.palette.brandBackgroundPrimary.main,
    }),
    ...(Array.isArray(sx) ? sx : [sx]),
  ];

  return (
    <Box {...boxProps} sx={composedSx}>
      {children}
    </Box>
  );
};
